import { createRequestTypes } from '../../utils';

export const SAVE_BUTTON_CLICKED = 'impurityModal/SAVE_BUTTON_CLICKED';
export const SAVE_RAWMAT_PROPORTION_IMPURITIES = createRequestTypes('impurityModal/SAVE_RAWMAT_PROPORTION_IMPURITIES');
